<template>
  <div v-if="!loading && loadTable" id="website-basket">
    <div class="vx-row" id="buyer-recipient-info">
      <div class="vx-col w-full hide-in-print">
        <vs-button
          type="button"
          class="float-left mx-2 mb-2"
          style="background-color: #444"
          @click.prevent="backToCurrentGrid()"
          >{{ $t("Back") }}</vs-button
        >
        <vs-button
          type="button"
          class="float-right bg_l_purple mb-4"
          @click.prevent="deviceInfo"
          v-has-permission="permission2"
          >{{ $t("DeviceInfo") }}</vs-button
        >
      </div>
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PartyInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table :data="basket" ref="table">
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td
                      v-if="basket.basketCustomerInfo.partyType == 'Legal'"
                    >
                      {{ $t("CompanyName") }}
                    </vs-td>
                    <vs-td
                      v-if="basket.basketCustomerInfo.partyType == 'Individual'"
                    >
                      {{ $t("CustomerName") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.basketCustomerInfo.name }}
                    </vs-td>
                  </vs-tr>

                  <vs-tr v-if="basket.basketCustomerInfo.partyType == 'Legal'">
                    <vs-td>
                      {{ $t("CompanyRegistrationNumber") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.basketCustomerInfo.companyRegistrationNumber }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr v-if="basket.basketCustomerInfo.partyType == 'Legal'">
                    <vs-td>
                      {{ $t("EconomicCode") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.basketCustomerInfo.economicCode }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr
                    v-if="basket.basketCustomerInfo.partyType == 'Individual'"
                  >
                    <vs-td>
                      {{ $t("SocialSecurityNumber") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.basketCustomerInfo.socialSecurityNumber }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Email") }}
                    </vs-td>
                    <vs-td>
                      <span v-if="basket.basketCustomerInfo.email">
                        {{ basket.basketCustomerInfo.email }}
                      </span>
                      <span v-if="!basket.basketCustomerInfo.email"> - </span>
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PhoneNumber") }}
                    </vs-td>
                    <template v-for="item in basket.basketCustomerInfo.phones">
                      <td
                        v-if="item.area"
                        :key="item.id"
                        style="direction: ltr"
                      >
                        <span>{{ item.area }}-</span>
                        {{ item.number }}
                      </td>
                    </template>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PostalCode") }}
                    </vs-td>
                    <template
                      v-for="item in basket.basketCustomerInfo.addressesInfo"
                    >
                      <td v-if="item" :key="item.id">
                        {{ item.postalCode }}
                      </td>
                    </template>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Address") }}
                    </vs-td>
                    <template
                      v-for="item in basket.basketCustomerInfo.addressesInfo"
                    >
                      <td v-if="item" :key="item.id">
                        {{ item.provinceInfo.name }}-{{
                          item.provinceInfo.cityName
                        }}-{{ item.address }}
                      </td>
                    </template>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("RecipientInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table :data="basket.recipientInfo" ref="table">
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ $t("FullName") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.recipientInfo.fullName }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PhoneNumber") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.recipientInfo.phoneNumber }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PostalCode") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.recipientInfo.addressInfo.postalCode }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("Address") }}
                    </vs-td>
                    <vs-td>
                      {{ basket.recipientInfo.addressInfo.province.name }}-
                      {{ basket.recipientInfo.addressInfo.province.cityName }}-
                      {{ basket.recipientInfo.addressInfo.address }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("InvoiceRequired") }}
                    </vs-td>
                    <vs-td v-if="basket.invoiceRequire == true">
                      {{ $t("Yes") }}
                    </vs-td>
                    <vs-td v-if="basket.invoiceRequire == false">
                      {{ $t("No") }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td class="white hide-in-print"> - </vs-td>
                    <vs-td class="white hide-in-print"> - </vs-td>
                  </vs-tr>
                  <vs-tr v-if="basket.basketCustomerInfo.partyType == 'Legal'">
                    <vs-td class="white hide-in-print"> - </vs-td>
                    <vs-td class="white hide-in-print"> - </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <vs-button
                type="gradient"
                icon-pack="feather"
                class="mx-2 bg_l_purple float-right py-1 px-5"
                v-show="onShowCommission"
                @click="isShowBoxCommission"
                >{{ $t("Commission") }}</vs-button
              ><span>
                {{ $t("OrdersList") }}
                {{ $t("From") }}
                {{ $t("Contract") }}:
                <span class="color-primary">{{
                  basket.basketContractInfo.contractTitle
                }}</span>
              </span>
              <span class="date mt-2 mx-8 float-right">
                <span> {{ $t("CreateOn") }}: </span>
                <span class="float-right">
                  {{ basket.createOn }}
                </span>
              </span>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl" id="draft-order-tbl">
              <div v-show="showBoxCommission" class="vx-row w-full mb-4">
                <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
                  <vs-input
                    type="gradient"
                    icon-pack="feather"
                    class="inputx"
                    name="fName"
                    :label="$t('AmountCommission')"
                    v-model="amountCommissionManual"
                    @keyup.enter="submitCommission()"
                  />
                </div>
                <div>
                  {{ $t("Rials") }}
                  <vs-button
                    type="filled"
                    class="submit-btn py-1 px-4 mt-6 mx-4"
                    @click="submitCommission()"
                    >{{ $t("CommissionSubmit") }}</vs-button
                  >
                </div>
              </div>
              <vs-table :data="basket.basketItems" ref="table">
                <template slot="thead">
                  <vs-th style="width: 3%">#</vs-th>
                  <vs-th style="width: 13%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("ProductColor") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("ProductWarranty") }}</vs-th>
                  <vs-th style="width: 4%">{{ $t("Count") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("UnitPrice") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("SumOfDiscount") }}</vs-th>
                  <vs-th style="width: 10%">{{
                    $t("TotalAmountWithTax")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td>
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].basketProductInfo.productInfoName }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].basketProductInfo.productInfoItemCode }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].basketProductInfo.color.colorName }}
                    </vs-td>
                    <vs-td>
                      {{
                        data[indextr].basketProductInfo.warranty.warrantyName
                      }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].count }}
                    </vs-td>
                    <vs-td>
                      {{
                        Number(data[indextr].contractBasePrice).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td>
                      <span v-if="data[indextr].totalDiscountsAmount">
                        {{
                          Number(
                            data[indextr].totalDiscountsAmount
                          ).toLocaleString()
                        }}
                        ریال
                      </span>
                      <span v-else> - </span>
                    </vs-td>
                    <vs-td>
                      {{
                        Number(
                          data[indextr].totalBaseConsumerPrice
                        ).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr style="background-color: #007470; color: white">
                    <vs-td>مجموع</vs-td>
                    <vs-td> </vs-td>
                    <vs-td> </vs-td>
                    <vs-td> </vs-td>
                    <vs-td> </vs-td>
                    <vs-td
                      >{{ Number(basket.sumOfCount).toLocaleString() }}
                    </vs-td>
                    <vs-td> </vs-td>
                    <vs-td>
                      {{ Number(basket.sumOfDiscountAmount).toLocaleString() }}
                    </vs-td>
                    <vs-td>
                      {{
                        Number(
                          basket.sumOfTotalBaseConsumerPrice
                        ).toLocaleString()
                      }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        v-bind:class="{ 'p-w-50': basket.payments.length <= 1 || showMore }"
      >
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4 class="d-inline float-left">{{ $t("OrderInfo") }}</h4>
              <vs-chip
                transparent
                color="warning"
                class="float-right hide-in-print"
              >
                <span v-if="basket.basketFlowState == '1'">
                  {{ $t("ReviewQueue") }}
                </span>
                <span v-if="basket.basketFlowState == '2'">
                  {{ $t("Confirmed") }}
                </span>
                <span v-if="basket.basketFlowState == '3'">
                  {{ $t("Processing") }}
                </span>
                <span v-if="basket.basketFlowState == '4'">
                  {{ $t("Sent") }}
                </span>
                <span v-if="basket.basketFlowState == '5'">
                  {{ $t("Delivered") }}
                </span>
              </vs-chip>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table :data="basket" ref="orderTable">
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ $t("OrderNumber") }}
                    </vs-td>
                    <vs-td>
                      {{ siteOrderNumber }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("TotalAmount") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(basket.sumOfFinalPrice).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("ShippingFee") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(basket.shippingFee).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("ToPay") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(basket.totalAmount).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PaymentStatus") }}
                    </vs-td>
                    <vs-td>
                      <span v-if="basket.paymentType == 1">
                        {{ $t("CreditPayment") }}
                      </span>
                      <span v-if="basket.paymentType == 2">
                        {{ $t("OnlinePayment") }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        v-bind:class="{ 'p-w-50': basket.payments.length <= 1 || showMore }"
      >
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PaymentInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div
              class="vx-card__body custom-tbl v-table"
              v-bind:class="{ customheight: showMore }"
            >
              <vs-table
                :data="basket.payments"
                ref="paymentTable"
                id="order-payment-tbl"
              >
                <template slot-scope="{ data }">
                  <span v-for="(tr, indextr) in data" :key="indextr">
                    <vs-tr>
                      <vs-td>
                        {{ $t("PaymentGateway") }}
                      </vs-td>
                      <vs-td :data="data[indextr].bankType">
                        <span v-if="data[indextr].bankType == 1">ملت</span>
                        <span v-else-if="data[indextr].bankType == 2">ملی</span>
                        <span v-else-if="data[indextr].bankType == 3"
                          >مسکن</span
                        >
                        <span v-else-if="data[indextr].bankType == 4">سپه</span>
                        <span v-else-if="data[indextr].bankType == 5"
                          >پاسارگاد</span
                        >
                        <span v-else-if="data[indextr].bankType == 6"
                          >پارسیان</span
                        >
                        <span v-else-if="data[indextr].bankType == 7"
                          >ایران خودرو</span
                        >
                        <span v-else-if="data[indextr].bankType == 8"
                          >اسنپ‌پی</span
                        >
                        <span v-else>متفرقه</span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("ReceiptNumber") }}
                      </vs-td>
                      <vs-td>
                        <span :data="data[indextr].referenceId">
                          {{ data[indextr].referenceId }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="data[indextr].paymentType == 1">
                      <vs-td>
                        {{ $t("OnlinePaymentId") }}
                      </vs-td>
                      <vs-td>
                        <span>
                          {{ data[indextr].bankPaymentIdInWebsite }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="data[indextr].paymentType != 1">
                      <vs-td>
                        {{ $t("CashPaymentId") }}
                      </vs-td>
                      <vs-td>
                        <span>
                          {{ data[indextr].id }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Date") }}
                      </vs-td>
                      <vs-td style="direction: ltr">
                        <div v-if="basket.paymentType == 1">
                          {{ basket.actionTime }}
                        </div>
                        <div v-if="basket.payments && basket.paymentType == 2">
                          {{ data[indextr].referenceTime }}
                        </div>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Fee") }}
                      </vs-td>
                      <vs-td :data="data[indextr].amount">
                        {{ Number(data[indextr].amount).toLocaleString() }} ریال
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Status") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="data[indextr].state == 1">{{
                          $t("Create")
                        }}</span>
                        <span v-if="data[indextr].state == 2">{{
                          $t("Token")
                        }}</span>
                        <span v-if="data[indextr].state == 3">{{
                          $t("CallBackFromBank")
                        }}</span>
                        <span v-if="data[indextr].state == 4">{{
                          $t("Confirm")
                        }}</span>
                        <span v-if="data[indextr].state == 5">{{
                          $t("Reject")
                        }}</span>
                      </vs-td>
                    </vs-tr>
                  </span>
                </template>
              </vs-table>
              <vs-button
                type="button"
                :icon="showMore ? 'expand_more' : 'expand_less'"
                class="read-more-btn hide-in-print"
                v-if="basket.payments.length > 1"
                @click="showMore = !showMore"
              >
                {{ showMore ? "مشاهده بیشتر" : "مشاهده کم‌تر" }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row hide-in-print">
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-2">
        <vs-button
          type="button"
          icon="print"
          class="float-left ml-4 purple"
          @click.prevent="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <vs-button
          type="filled"
          icon="done"
          class="float-right mr-4"
          @click.prevent="showConfirmationPopup('confirm')"
          v-has-permission="permission1"
          v-if="basket.basketFlowState == '1'"
          >{{ $t("ConfirmOrder") }}</vs-button
        >
        <vs-button
          type="button"
          icon="clear"
          class="float-right reject-btn"
          @click.prevent="showConfirmationPopup('reject')"
          :disabled="disabledReject"
          v-if="
            basket.basketFlowState == '1' ||
            basket.basketFlowState == '5' ||
            basket.basketState == 'Confirm'
          "
          v-has-permission="permission3"
          >{{ $t("RejectOrder") }}</vs-button
        >

        <vs-button
          type="filled"
          icon="assignment_turned_in"
          class="float-right mr-4 btn_l_blue"
          @click.prevent="orderDelivered(basket.id)"
          :disabled="disabledDelivered"
          v-if="basket.basketFlowState == '4'"
          >{{ $t("Delivered") }}</vs-button
        >
      </div>
    </div>
    <device-popup
      :show="DevicePopup"
      @finish="onfinish"
      :Basketid="basket.id"
    ></device-popup>
    <order-confirmation-description
      :show="showOrderConfirmationDescriptionPopup"
      :mode="orderConfirmationDescriptionPopupMode"
      @close="showOrderConfirmationDescriptionPopup = false"
      @submitForm="handleConfirmation"
    ></order-confirmation-description>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DevicePopup from "./DevicePopup.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_webOrderdetails.scss";

import OrderConfirmationDescription from "./OrderConfirmationDescription.vue";

export default {
  name: "basketManagement_WebSiteBaskets_BasketDetails",

  data() {
    return {
      permission3: "ChangeStateToRejectBasket",
      permission1: "ChangeStateToDeliver",
      permission2: "GetDeviceInfoThatClosedBasketBy",
      loadTable: false,
      disabledReject: false,
      siteOrderNumber: "",
      DevicePopup: false,
      disabledDelivered: false,
      showMore: true,
      onShowCommission: false,
      pageNumber: 0,
      showBoxCommission: false,
      amountCommissionManual: "",
      commissionModel: {
        basketId: "",
        commissionAmount: "",
      },
      showOrderConfirmationDescriptionPopup: false,
      orderConfirmationDescriptionPopupMode: "",
    };
  },
  computed: {
    ...mapGetters({
      basket: "basket/details",
      loading: "basket/loading",
    }),
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loadTable = true;
    }, 100);
  },
  methods: {
    ...mapActions({
      fetchSingle: "basket/fetchSingle",
      confirmBasketOrder: "basket/confirmBasket",
      rejectBasketOrder: "basket/rejectBasket",
      basketOrderDelivered: "basket/basketDelivered",
      submitCommissionMethods: "basket/submitCommissionApi",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.siteOrderNumber = "APO-" + this.basket.id;
      });
      this.pageNumber = this.$route.params.tabIndex;
      if (this.pageNumber == 1 || this.pageNumber == 2) {
        this.onShowCommission = true;
      } else {
        this.onShowCommission = false;
      }
      this.commissionModel.basketId = id;
    },
    isShowBoxCommission() {
      this.showBoxCommission = !this.showBoxCommission;
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/WebSiteBaskets/Index",
        query: {
          referencePageInfo: {
            tabIndex: this.$route.params.tabIndex,
            numberRowsPerPage: this.$route.query.numberRowsPerPage,
          },
        },
      });
    },
    submitCommission() {
      this.submitCommissionMethods(this.commissionModel).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "مبلغ تخفیف با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.amountCommission = this.amountCommissionManual;
      });
    },
    handleConfirmation(description) {
      this.showOrderConfirmationDescriptionPopup = false;
      if (this.orderConfirmationDescriptionPopupMode === "confirm") {
        const payload = {
          basketId: this.basket.id,
          description: description,
        };
        this.confirmBasketOrder(payload).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "سفارش مورد‌نظر تایید شد!",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.$router.push({
              path: "/WebSiteBaskets/Index",
              query: {
                referencePageInfo: {
                  tabIndex: +this.$route.params.tabIndex + 1,
                  numberRowsPerPage: this.$route.query.numberRowsPerPage,
                },
              },
            });
          });
        });
      } else if (this.orderConfirmationDescriptionPopupMode === "reject") {
        const payload = {
          basketId: this.basket.id,
          reasonOfReject: description,
        };
        this.rejectBasketOrder(payload).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "سفارش مورد‌نظر رد شد!",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.$router.push({
              path: "/WebSiteBaskets/Index",
              query: {
                referencePageInfo: {
                  tabIndex: this.$route.params.tabIndex,
                  numberRowsPerPage: this.$route.query.numberRowsPerPage,
                },
              },
            });
          });
        });
      }
    },
    showConfirmationPopup(mode) {
      this.orderConfirmationDescriptionPopupMode = mode;
      this.showOrderConfirmationDescriptionPopup = true;
    },
    orderDelivered(id) {
      this.$swal({
        title: "آیا از تعیین وضعیت این سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.disabledDelivered = true;
          this.basketOrderDelivered(id).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش مورد نظر به وضعیت تحویل داده شده تغییر یافت!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push({
                path: "/WebSiteBaskets/Index",
                query: {
                  referencePageInfo: {
                    tabIndex: +this.$route.params.tabIndex + 1,
                    numberRowsPerPage: this.$route.query.numberRowsPerPage,
                  },
                },
              });
            });
            this.disabledDelivered = false;
          });
          this.disabledDelivered = false;
        }
      });
    },
    printWindow() {
      window.print();
    },
    deviceInfo() {
      this.DevicePopup = true;
    },
    onfinish() {
      this.DevicePopup = false;
    },
  },
  components: {
    DevicePopup,
    OrderConfirmationDescription,
  },
  watch: {
    amountCommissionManual(value) {
      if (value) {
        var m = parseFloat(value.replace(/,/g, ""), 10);
        this.commissionModel.commissionAmount = m;
        this.amountCommissionManual = m.toLocaleString();
      } else {
        this.amount = null;
        this.model.amount = null;
      }
    },
  },
};
</script>
